// extracted by mini-css-extract-plugin
module.exports = {"container":"main_container__2qVeB","heading":"main_heading__5Uzz4","please":"main_please__3WKzE","mascot":"main_mascot__29EBT"};